import { ReactComponent as Mug } from "../assets/svg/mug-hot-alt.svg";
import {ReactComponent as Colorfullogo} from "../assets/svg/ColorfulBioLogo.svg"
import {ReactComponent as BlackLogo} from "../assets/svg/BlackBioLogo.svg"
import {ReactComponent as WhiteLogo} from "../assets/svg/WhiteBioLogo.svg"

const SVG = {
  Mug,
  Colorfullogo,
  BlackLogo,
  WhiteLogo
};

export default SVG;
